import $ from 'jquery';

$(function() {

    $(window).on('scroll', function() {
        if ($(window).scrollTop() >= 75) {
            $('body').addClass('scrolled');
        } else {
            $('body').removeClass('scrolled');
        }
    });

    $('.js-menu-open').on('click', function() {
        $('.js-menu').addClass('active');
    });

    $('.js-menu-close').on('click', function() {
        $('.js-menu').removeClass('active');
    });

    // Process flow steps
    $('.process-flow-step-info').on('click', function() {
        const $parent = $(this).parents('.process-flow-item');
        console.log($(this), $parent);
        $parent.find('.process-flow-content').slideToggle();
    });
    
});